var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38477 10.4463H7.26953C7.70262 10.4465 8.05355 10.7974 8.05371 11.2305V17.1152C8.05371 17.5485 7.70272 17.9002 7.26953 17.9004H1.38477C0.951434 17.9004 0.599609 17.5486 0.599609 17.1152V11.2305C0.599772 10.7973 0.951534 10.4463 1.38477 10.4463ZM13.6729 10.4463C15.7311 10.4463 17.4003 12.1146 17.4004 14.1729C17.4004 16.2312 15.7312 17.9004 13.6729 17.9004C11.6146 17.9003 9.94629 16.2311 9.94629 14.1729C9.94641 12.1147 11.6147 10.4464 13.6729 10.4463ZM1.38477 1.09961H7.26953C7.70272 1.09977 8.05371 1.45153 8.05371 1.88477V7.76953C8.05355 8.20262 7.70262 8.55355 7.26953 8.55371H1.38477C0.951535 8.55371 0.599772 8.20272 0.599609 7.76953V1.88477C0.599609 1.45143 0.951435 1.09961 1.38477 1.09961ZM10.7305 1.09961H16.6152C17.0486 1.09961 17.4004 1.45143 17.4004 1.88477V7.76953C17.4002 8.20272 17.0485 8.55371 16.6152 8.55371H10.7305C10.2974 8.55355 9.94645 8.20262 9.94629 7.76953V1.88477C9.94629 1.45153 10.2973 1.09977 10.7305 1.09961Z",
    stroke: "none",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps_icon.278f37c413c7e22b571f8fa2678f112e.svg";
export { ForwardRef as ReactComponent };